<template>
    <div class="mediver-register-container">
        <div class="register-logo-box">
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" />
            <div class="sub-title">회원가입</div>
        </div>
        <form class="register-box" @submit.prevent="submit">
            <div class="register-row">
                <div class="notice-error" v-if="error.name">{{ error.name }}</div>
                <label class="register-label" for="name">이름</label>
                <input id="name" class="register-input" v-model="name" placeholder="이름 (실명)" autocomplete="name" ref="name" maxlength="10" @keydown.space.prevent/>
            </div>
            <!-- <div class="register-row">
                <label class="register-label" for="userid">아이디</label>
                <input id="name" class="register-input" v-model="userid" placeholder="아이디" autocomplete="name" @input="onIdChange"/>
                <button type="button" class="dup-check-btn" @click="dupCheckID">중복확인</button>
            </div> -->
            <div class="register-row row">
                <div class="notice-error" v-if="error.email">{{ error.email }}</div>
                <label class="register-label" for="email">이메일</label>
                <div class="register-input-group">
                    <input id="email" class="register-input" v-model="email" placeholder="이메일" autocomplete="username" @input="onEmailChange($event)" ref="email" maxlength="200" @keydown.space.prevent/>
                    <button type="button" class="dup-check-btn" @click="dupCheckEmail">중복확인</button>
                </div>
            </div>
            <div class="register-row">
                <div class="notice-error" v-if="error.password">{{ error.password }}</div>
                <label class="register-label" for="password">비밀번호</label>
                <h6 class="password-guide">
                    * 비밀번호는 영문, 숫자, 특수문자를 조합하여 8자 이상 입력해야 합니다.<br/>
                    * 사용 가능한 특수문자: ~ ! @ # % ^ & * _ -
                </h6>
                <input id="password" type="password" class="register-input" v-model="password" placeholder="비밀번호" autocomplete="new-password" ref="password" maxlength="30" @keydown.space.prevent/>
            </div>
            <div class="register-row">
                <div class="notice-error" v-if="error.passwordCheck">{{ error.passwordCheck }}</div>
                <label class="register-label" for="passwordCheck">비밀번호 확인</label>
                <input id="passwordCheck" type="password" class="register-input" v-model="passwordCheck" placeholder="비밀번호 재입력" autocomplete="new-password" maxlength="30" ref="passwordCheck" @keydown.space.prevent/>
            </div>
            <div class="register-row">
                <div class="notice-error" v-if="error.phone">{{ error.phone }}</div>
                <label class="register-label" for="phone">전화번호</label>
                <input id="phone" class="register-input" v-model="phone" placeholder="휴대폰 번호" autocomplete="tel" ref="phone" maxlength="20" @keydown.space.prevent @input="filterPhone"/>
            </div>
            <!-- <div class="register-row">
                <label class="register-label" for="level">권한</label>
                <select id="level" class="register-select" v-model="level">
                    <option value="">선택</option>
                    <option value="0">사용자</option>
                    <option value="1">관리자</option>
                </select>
            </div> -->
            <div class="register-row">
                <div class="notice-error" v-if="error.hospital">{{ error.hospital }}</div>
                <label class="register-label" for="hospital">병원명</label>
                <select id="hospital" class="register-select" v-model="hospital">
                    <option value="" disabled hidden>선택</option>
                    <option :value="row.instCd" v-for="row in instList" :key="row.instCd">{{row.instName}}</option>
                </select>
            </div>
            <!-- <div class="register-row">
                <label class="register-label" for="dept">부서</label>
                <select id="dept" class="register-select" v-model="dept">
                    <option value="">선택</option>
                    <option value="0">진료과</option>
                    <option value="1">의무지원과</option>
                    <option value="2">행정과</option>

                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="position">직책</label>
                <select id="position" class="register-select" v-model="position">
                    <option value="">선택</option>
                    <option value="0">과장</option>
                    <option value="1">팀장</option>
                    <option value="2">사원</option>
                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="role">담당 업무</label>
                <select id="role" class="register-select" v-model="role">
                    <option value="">선택</option>
                    <option value="0">진단 전담</option>
                    <option value="1">처방 전담</option>
                    <option value="2">겸임</option>
                    <option value="3">시스템 관리자</option>
                </select>
            </div> -->
            <button type="submit" class="register-btn">회원가입</button>
            <div class="register-note">가입 후 관리자 승인 절차가 있습니다.</div>
            <div class="register-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toFindId')">아이디 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toResetPassword')">비밀번호 찾기</span>
            </div>
        </form>
    </div>
</template>
<script>
    import api, {urls} from '@/api'
    import { useAppAlert }  from '@/composables/useAppAlert';

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    export default {
        name: 'Register',
        data() {
            return {
                name           : '',
                email          : '',
                userid         : '',
                password       : '',
                passwordCheck  : '',
                phone          : '',
                hospital       : '',
                dept           : '',
                position       : '',
                role           : '',
                level          : '',
                isEmailChecked : false,  // 중복확인 완료 플래그 추가
                isIdChecked    : false,  // 중복확인 완료 플래그 추가
                instList       : [],

                // 저장 시 오류 내용 표기
                error: {
                    name          : '',
                    email         : '',
                    password      : '',
                    passwordCheck : '',
                    phone         : '',
                    hospital      : '',
                }
            };
        },
        methods: {
            onEmailChange(event) {
                let value = event.target.value;

                // 1. 한글 제거
                value = value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');

                // 2. 특수문자 중 이메일에 적합하지 않은 문자 제거
                // (필요하다면 더 엄격하게 필터링 가능)
                // 예: 슬래시(/), 공백 등
                value = value.replace(/[\/\s]/g, '');

                // 3. 이메일 정규식 엄격 체크
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                this.email = value;

                // 4. 유효성 검사 결과 저장
                this.emailError = !emailPattern.test(this.email);

                // 5. 이메일 변경 시마다 중복 확인 플래그 초기화
                this.isEmailChecked = false;
            },
            onIdChange() {
                // 이메일 변경 시 중복확인 플래그 초기화
                this.isIdChecked = false;
            },

            dupCheckEmail() {
                if (!this.email) {
                    showAlert("이메일을 입력해주세요.");
                    return;
                }

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.email)) {
                    showAlert("올바른 이메일 형식을 입력해주세요.");
                    return;
                }

                api.post(urls.login.checkEmail, { email: this.email })
                    .then(response =>{
                        if (response.data  === 0) {
                            showAlert("이미 사용 중인 이메일입니다. 다른 이메일을 입력해주세요.");
                            this.isEmailChecked = false;
                        } else {
                            showAlert("사용 가능한 이메일입니다.");
                            this.isEmailChecked = true;
                        }
                    })
                    .catch(e => {
                        showAlert("이메일 중복 확인 중 오류가 발생했습니다.");
                        this.isEmailChecked = false;
                    })
            },
            // async dupCheckID() {
            //     if (!this.userid) {
            //         alert("아이디을 입력해주세요.");
            //         return;
            //     }
            //     api.post(urls.login.checkID, { userid: this.userid })
            //         .then(response =>{
            //             if (response.data  === 0) {
            //                 alert("이미 사용 중인 아이디입니다. 다른 아이디을 입력해주세요.");
            //                 this.isIdChecked = false;
            //             } else {
            //                 alert("사용 가능한 아이디입니다.");
            //                 this.isIdChecked = true;
            //             }
            //         })
            //         .catch(e => {
            //             alert("아이디 중복 확인 중 오류가 발생했습니다.");
            //             this.isIdChecked = false;
            //         })
            //
            // },

            async submit() {
                this.error = {
                    name: '',
                    email: '',
                    password: '',
                    passwordCheck: '',
                    phone: '',
                    hospital: ''
                }

                // 입력값 유효성 검사
                // const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#%^&*_-])[A-Za-z\d~!@#%^&*_-]{8,}$/;
                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#%^&*_\-])[A-Za-z\d~!@#%^&*_\-]{8,}$/;
                const phoneRegex = /^0\d{1,2}-?\d{3,4}-?\d{4}$/;

                this.error.name = this.name ? '' : "* 이름을 입력해주세요."
                if(!this.email){
                    this.error.email = "* 이메일을 입력해주세요."
                }else if(!this.isEmailChecked){
                    this.error.email = "* 이메일 중복확인을 해주세요."
                }
                if(!this.password){
                    this.error.password = "* 비밀번호를 입력해주세요."
                }else if(!regex.test(this.password)){
                    this.error.password = "* 영문, 숫자, 특수문자를 조합하여 작성해주시길 바랍니다."
                }
                if(!this.passwordCheck){
                    this.error.passwordCheck = "* 비밀번호 확인을 입력해주세요."
                }else if(this.password != this.passwordCheck){
                    this.error.passwordCheck = "* 비밀번호가 일치하지 않습니다."
                }
                // this.error.phone = this.phone ? '' : "* 전화번호를 입력해주세요."
                if (!this.phone) {
                    this.error.phone = "* 전화번호를 입력해주세요.";
                } else if (!phoneRegex.test(this.phone)) {
                    this.error.phone = "* 전화번호 형식을 다시 확인해주세요. (예시: 010-1234-5678)";
                } else {
                    this.error.phone = "";
                }
                this.error.hospital = this.hospital ? '' : "* 병원명을 선택해주세요."
                const firstErrorField = Object.keys(this.error).find(key => this.error[key]);
                if (firstErrorField) {
                    this.$refs[firstErrorField].focus();
                    return;
                }
                // if (!this.level) {
                //     alert("권한을 선택해주세요.");
                //     return;
                // }
                // if (!this.dept) {
                //     alert("부서를 선택해주세요.");
                //     return;
                // }
                // if (!this.position) {
                //     alert("직책을 선택해주세요.");
                //     return;
                // }
                // if (!this.role) {
                //     alert("담당업무를 선택해주세요.");
                //     return;
                // }

                api.post(urls.login.register, {
                        name: this.name,
                        id: this.userid,
                        email: this.email,
                        password: this.password,
                        phone: this.phone,
                        role:this.role,
                        hospital: this.hospital,
                        dept: this.dept,
                        position: this.position,
                        level:this.level,
                    })
                    .then(response =>{
                        const result = response.data;

                        if (result === 1) {
                            this.error = '';
                            alert("회원가입 완료 되었습니다. 승인후 이용바랍니다.");
                            this.$emit('toLogin');
                            // this.$router.push('/'); // 성공시 메인으로 이동
                        } else {
                            this.error = result.message || '회원가입에 실패하였습니다.';
                            alert(this.error);
                        }
                    })
                    .catch(e => {
                        this.error = '회원가입 중 오류가 발생했습니다.';
                        alert(this.error);
                    })
            },
            getInstList(){
                api.get(urls.login.list)
                .then(res =>{
                    this.instList = res.data;
                })
            },
            filterPhone(event){
                event.target.value = event.target.value.replace(/[^0-9-]/g, '');
                this.phone = event.target.value;
            },
        },
        mounted() {
            this.getInstList()
        },
    };
</script>
